import { useContext } from 'react';
import { Config, ConfigNestedProp } from '../types/config';
import { ConfigContext } from '../context/ConfigStateContext';

export const useCfgParam = <T extends keyof Config>(
  ...params: [T, ConfigNestedProp<T>?, ...string[]]
) => {
  let parameter = useContext(ConfigContext);

  if (parameter === undefined) {
    throw new Error('useCfgParam must be used within a ConfigContextProvider');
  }

  let isParamInClientConfig = true;

  //search config deeply in config.json
  for (let i = 0; i < params.length; i++) {
    if (parameter[params[i]] !== undefined) {
      parameter = parameter[params[i]];
    } else {
      isParamInClientConfig = false;
      break;
    }
  }

  //return parameter if we have it in config.json
  return isParamInClientConfig ? parameter : null;
};
